<template>
  <section class="py-10">
    <v-container class="text-center">
      <h2 class="display-2 mb-3">{{ trans('app.social_proof_title') }}</h2>
      <div class="grey--text subtitle-1 mb-3">{{ trans('app.social_proof_subtitle') }}</div>
    </v-container>
    <v-container>
      <div class="text-center py-5 my-5" v-if="loading">
        <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
      </div>
      <v-row cols="12" v-if="loaded">
        <social-proof-item v-for="item,i in collection" :key="i" v-bind="item"></social-proof-item>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import api from "../../api";
import _ from "lodash";
import SocialProofItem from "./SocialProofItem";

export default {
  components: {
    "social-proof-item": SocialProofItem
  },

  data: () => ({
    collection: null,
    loading: false,
    loaded: false
  }),

  created: function() {
    this.loading = true;
    api.frontpage
      .social()
      .then(response => {
        this.collection = response.data;
        this.loaded = true;
      })
      .catch(error => {
        this.loaded = false;
      })
      .then(() => {
        this.loading = false;
      });
  }
};
</script>